import React from "react";
import "../../../style/slotbooking.css";
import {
  SLOT_PROCESSING_MIN,
  formatSlotDateLong,
  formatSlotTime,
  getSlotEndTime,
} from "../../../utils/slotBooking";

interface SlotTrioProps {
  slotDate?: string;
  slotTime?: string;
}

// Har scheduled screen pe: Scheduled Time | 90 Minutes | Expected Delivery
const SlotTrio: React.FC<SlotTrioProps> = ({ slotDate, slotTime }) => (
  <div className="slot-trio">
    <div>
      <small>Scheduled</small>
      <b>{formatSlotTime(slotTime) || "-"}</b>
      <span>{formatSlotDateLong(slotDate)}</span>
    </div>
    <div className="trio-mid">
      <i className="bi bi-arrow-right"></i>
      <span>{SLOT_PROCESSING_MIN} MIN</span>
    </div>
    <div>
      <small>Expected Delivery</small>
      <b>{formatSlotTime(getSlotEndTime(slotTime)) || "-"}</b>
      <span>{formatSlotDateLong(slotDate)}</span>
    </div>
  </div>
);

export default SlotTrio;
